module.exports = {
  become_our_partner: 'Devenez notre partenaire',
  select_language: 'Choisissez la langue :',
  privacy_intro_title: 'Politique de confidentialité',
  privacy_intro_paragraph:
    'Cet avis de confidentialité vous informe sur la manière dont nous protégeons vos données personnelles et sur les mesures que nous prenons pour les sécuriser.',
  privacy_paragraph_1:
    'Ici, vous pouvez découvrir quelles informations nous utilisons pour vous fournir notre ensemble de services de transport, comment nous utilisons vos informations pour assurer votre sécurité, et les choix et contrôles disponibles pour vous.\n\nDans cet avis, il est également indiqué tous les droits possibles que vous avez concernant la confidentialité de vos données. Les règles de protection des données sont mises en place pour protéger toutes les personnes impliquées.',
  privacy_paragraph_2:
    "Le terme « nous » fait référence à la société Nobel, constituée et enregistrée conformément aux lois du gouvernement. Le terme « vous » fait référence aux personnes qui utilisent notre service d'application pour demander, embaucher et/ou recevoir un service de transport.",

  personal_data_title: '1. Données personnelles que nous traitons',
  personal_data_paragraph:
    'Nous ne traitons que les informations nécessaires à vos besoins sur notre marketplace. Cela nous permet de vous fournir le meilleur service possible pour ce que vous cherchez à accomplir.',

  contact_details_title: 'Coordonnées :',
  contact_details_paragraph:
    "Nous vous demanderons vos informations personnelles telles que le nom, le numéro de téléphone et l'adresse e-mail afin de mieux vous aider. Informations sur le profil : Nous collectons certaines données pour vous aider à créer votre profil, comme vos adresses enregistrées et vos préférences linguistiques. Certains de nos services nécessitent des informations supplémentaires comme votre numéro de permis de conduire.",

  geolocation_title: 'Géolocalisation :',
  geolocation_paragraph:
    'En accédant à votre localisation, nous pouvons vous proposer une liste de services disponibles à votre emplacement, tels que des options de transport locales. Cela vous indiquera le temps estimé du trajet avec différentes options de dépenses. Il y a aussi des informations sur votre destination et les conditions de circulation.',

  payment_details_title: 'Détails de paiement :',
  payment_details_paragraph:
    'Informations sur la méthode de paiement utilisée, comme le montant facturé et la carte utilisée.',

  in_app_communication_title:
    "Enregistrements des communications dans l'application :",
  in_app_communication_paragraph:
    "Nous surveillons comment vous interagissez avec notre application régulièrement pour nous assurer que nous vous offrons un service de qualité. Nous conservons également un enregistrement de vos conversations dans l'application afin de pouvoir reprendre contact facilement si nécessaire.",

  limited_identification_data_title: "Les données d'identification limitées :",
  limited_identification_data_paragraph:
    "Nous collectons l'adresse IP de l'appareil sur lequel l'application a été installée.",

  ride_data_title: 'Données de trajet :',
  ride_data_paragraph:
    "Les données que nous collectons sur l'utilisation du service, telles que le temps du trajet, l'itinéraire pris, etc. Ces horodatages et statistiques nous permettent de faciliter la planification et sont précieux pour assurer la sécurité des conducteurs.",

  in_app_message_data_title: "Données des messages dans l'application :",
  in_app_message_data_paragraph:
    "Notre chat intégré dans l'application collecte des informations concernant la date, l'heure et le contenu de votre communication avec un conducteur. Image de l'utilisateur : à des fins de vérification, notre application stocke les images de profil des utilisateurs sur https://nobel.adminkloud.com/public Usage des données.",

  platform_data_collection:
    "L'utilisation de la plateforme collectera automatiquement des données.",
  usage_data_paragraph1:
    "Les données d'utilisation sont des informations concernant votre appareil, votre navigateur et votre activité sur le site web. Cela peut nous indiquer le type d'appareil depuis lequel vous vous connectez, le système d'exploitation, la version / numéro de version iTunes de votre navigateur (lorsque disponible), les pages que vous visitez sur notre site pour le support client ainsi que des services hors site comme la gestion d'inventaire de matériel et de logiciels.",
  usage_data_paragraph2:
    "Lors de votre visite sur notre site Web et de l'utilisation de l'application mobile, nous pouvons collecter certaines informations automatiquement sans interaction humaine. Cela inclut, mais ne se limite pas à, l'adresse IP, le type d'appareil, le numéro d'identification de l'appareil, le système d'exploitation de votre appareil, l'état du réseau et votre localisation actuelle. Même lorsque l'application n'est pas utilisée, l'appareil peut toujours récupérer votre position et permettre la demande de trajet.",

  website_app_visit_data:
    "Nous collectons des informations concernant vos visites sur notre site Web ou l'utilisation de notre application, y compris tout appareil mobile que vous utilisez.",

  cookies_tracking_technologies_title: 'Technologies de suivi et cookies',
  cookies_tracking_technologies_paragraph:
    "Nous utilisons des cookies, des balises, des balises de suivi et des scripts pour suivre l'activité sur notre service et stocker certaines informations. Ces technologies nous permettent de collecter et d'analyser des données afin d'améliorer les performances et d'offrir une meilleure expérience utilisateur.",

  browser_cookie_options:
    'Votre navigateur Internet vous permet de choisir quel type de cookies vous acceptez ou non. Sans cette capacité, certaines parties de notre site Web peuvent ne pas fonctionner correctement.',

  persistent_session_cookies:
    'Les cookies peuvent être des cookies "persistants" ou des cookies "session". La différence entre les deux est que les cookies persistants restent sur un ordinateur personnel ou un appareil mobile même lorsque l\'utilisateur ferme son navigateur web, tandis que les cookies de session sont supprimés dès qu\'ils ne sont plus utilisés.',

  cookies_usage_purpose:
    'Nous utilisons à la fois des cookies de session et des cookies persistants pour les objectifs ci-dessous :',

  necessary_essential_cookies: 'Cookies nécessaires / essentiels',
  session_cookies: 'Type : Cookies de session<br />Administered by: Nous',

  cookies_purpose_title: 'But :',
  cookies_purpose_paragraph:
    'Les cookies sont utilisés pour authentifier les utilisateurs et prévenir les fraudes. Ils vous aident à naviguer sur le site Web et à utiliser certains des services disponibles pour vous. Les cookies nous permettent de vous fournir les services que vous avez demandés, ce qui est important pour notre entreprise. Sans eux, nous ne pourrions pas vous fournir ces services et rencontrerions des difficultés à le faire.',

  cookies_policy_notice_title:
    "Cookies de politique / Acceptation de l'avis de cookies",
  persistent_cookies: 'Type : Cookies persistants<br />Administered by: Nous',

  cookies_acceptance_paragraph:
    "Ces cookies identifient si un visiteur a accepté ou non l'utilisation des cookies sur le site Web.",

  functionality_cookies_paragraph:
    "Les cookies de fonctionnalité permettent d'offrir une expérience personnalisée sur notre site Web. Ils nous aident à mémoriser vos préférences, à afficher les détails de votre compte et plus encore. Ces cookies sont utilisés sur le site pour vous offrir une expérience plus agréable et nous éviter de devoir vous redemander vos préférences.",

  cookies_functionality_paragraph:
    "Pour plus d'informations sur les cookies que nous utilisons et vos choix concernant les cookies, veuillez consulter notre politique de cookies.",

  cookies_more_info:
    "Il s'agit de la politique de cookies qui décrit nos cookies et vos choix.",

  purpose_of_processing_title: '2. Objectif du traitement',
  purpose_of_processing_paragraph_1:
    'Nous traitons vos données personnelles afin de vous fournir les services dont vous avez besoin de manière plus efficace :',
  connect_driver_title: 'Pour vous connecter avec un conducteur :',
  connect_driver_paragraph:
    "Nous collectons des données personnelles afin de nous connecter avec les utilisateurs qui cherchent à être pris en charge et déposés. Ces services incluent des voitures, des vélos et des trottinettes disponibles dans les zones proches. Les messages instantanés que l'application utilise peuvent être utilisés pour le service client et pour résoudre les litiges entre conducteurs et passagers. Cela est également utile lorsqu'ils utilisent ces données pour améliorer leurs produits et services, ainsi que pour les analyser.",
  track_ride_title: 'Nous vous aidons à suivre votre trajet :',
  track_ride_paragraph:
    "Nous aidons les conducteurs à se regrouper à des endroits spécifiques et leur montrons où se trouvent les passagers qu'ils prennent ou déposent. Les conducteurs peuvent également suivre l'itinéraire sur leur écran pour gagner du temps et des efforts, et s'assurer qu'ils ont à la fois leur numéro de téléphone et leur géolocalisation à proximité afin de ne jamais manquer un appel ou un message des passagers. Ces données sont collectées uniquement lorsque l'application est activée (en cours d'utilisation). Les conducteurs dans certains pays ne peuvent pas voir le numéro de téléphone du passager dans l'application après que l'application a été fermée. Cela est fait pour éviter que des informations personnelles ne soient accessibles aux conducteurs.",
  smooth_journey_title: 'Pour assurer votre voyage sans encombre :',
  smooth_journey_paragraph:
    'Les données de géolocalisation sont utilisées pour permettre aux employés d’atteindre automatiquement leurs destinations et réduire la perte de temps engendrée par le fait d’être dans le mauvais endroit. Cela aide également à garantir que les facturations sont correctes.',
  app_performance_title:
    "Nous assurons la performance optimale de l'application :",
  app_performance_paragraph:
    'Nous utilisons vos informations de contact pour vous notifier des modifications apportées à notre application. Nous apprécions que vous continuiez à utiliser notre service, et ces mises à jour vous aideront à vous assurer que vous utilisez la dernière version de notre service. Nous collectons des données limitées de votre appareil pour améliorer notre service (adresse IP et données qui vous aident à vous connecter à Internet). Ces vérifications aident à sécuriser votre compte et à vérifier votre authentification.',
  quick_ride_title:
    'Pour vous offrir un trajet rapide, bon marché et pratique :',
  quick_ride_paragraph:
    'Nous collectons des données sur les trajets empruntés par nos passagers et conducteurs pour analyser la couverture géographique. Cette fonctionnalité nous permet de trouver les itinéraires les plus efficaces pour les conducteurs et nos trottinettes. Elle aide également à garantir que nos employés sont proches des clients.',
  collect_payment_title: 'Nous collectons votre paiement :',
  collect_payment_paragraph:
    'Nous obtenons des informations de paiement pour traiter les paiements des passagers pour les conducteurs utilisant notre application de covoiturage. Elles sont généralement utilisées pour des transactions telles que le covoiturage et les taxis.',
  maintain_standards_title: 'Nous maintenons et promouvons des normes :',
  maintain_standards_paragraph:
    "Nous collectons des données sur les trajets, tels que la conclusion d'un trajet ou la date à laquelle il a eu lieu. Cela nous permet de favoriser la sécurité des clients et le respect de nos conditions générales. Nous souhaitons également nous assurer que chaque personne termine son expérience avec nous en étant satisfaite. Le service client est un aspect important de toute entreprise, et les retours sur la qualité de votre support client peuvent être utiles. Cela permet de résoudre les litiges et renforce le sentiment que votre entreprise se soucie de l'expérience du client.",
  keep_informed_title: 'Nous vous tenons informé :',
  keep_informed_paragraph:
    "Nous utiliserons votre nom, numéro de téléphone et adresse e-mail pour vous informer si votre trajet est terminé ou pour vous envoyer d'autres informations liées à votre trajet.",

  legal_basis_title: '3. Base légale',
  legal_basis_paragraph_1:
    'Nous sommes autorisés à utiliser vos données de la manière décrite ci-dessus si vous avez une raison valable de le faire. Vos informations sont toujours associées à un besoin explicite de votre part, et nous nous assurons que toute utilisation est justifiée.',
  legal_basis_paragraph_2:
    'Nous traitons vos données personnelles pour créer le service personnalisé que vous souhaitez. Les données personnelles peuvent être traitées pour respecter nos termes et conditions, afin de vous offrir un service inégalé.',
  legal_basis_paragraph_3:
    "Nous confirmons avec vous si nous avons besoin de vos données personnelles pour traiter votre demande ou si cela relève de l'intérêt légitime. Nos intérêts légitimes incluent la fourniture d'un service innovant, personnalisé et sécurisé à nos passagers et partenaires. Cela se fait au détriment d'autres intérêts - y compris la rentabilité. Nos intérêts légitimes incluent des activités telles que l'investigation de fraude et d'autres activités malveillantes, le maintien de la sécurité de nos systèmes et la réponse aux activités criminelles potentielles.",
  legal_basis_paragraph_4:
    "Nous nous appuyons parfois sur d'autres bases légales lorsque :",
  legal_basis_paragraph_5:
    "Le respect d'une obligation légale, telle que le traitement des données lorsque cela est requis, peut être bénéfique. Cela se produit, par exemple, s'il existe une demande légale valide.",
  legal_basis_paragraph_6:
    "En cas d'urgence ou lorsqu'il y a une menace pour la vie.",
  legal_basis_paragraph_7:
    "Nous nous efforçons toujours d'être transparents dans toutes nos communications avec vous. Cela inclut les exigences de consentement pour des utilisations spécifiques ainsi que des informations sur la manière dont nous examinons, utilisons et conservons vos métadonnées.",
  legal_basis_paragraph_8:
    "Obtenir des informations personnelles pour compléter un contrat est important et peut permettre à l'entreprise d'éviter certaines conséquences juridiques. Cela peut également signifier qu'ils ne peuvent pas vous fournir de services. Lorsque vous téléchargez notre application, nous collectons et traitons vos données personnelles, telles que les informations de localisation, afin que les chauffeurs puissent vous localiser rapidement. Refuser de partager votre localisation empêchera la direction du chauffeur et la recherche de réservations. Nous ne vous permettrons pas de vous inscrire ou d'utiliser votre compte si nous avons des raisons de penser que vous essayez de contourner les obligations.",

  recipients_title: '4. Destinataires',
  recipients_paragraph_1:
    "Nous ne travaillons qu'avec des partenaires et des autorités de confiance. Nous partageons toujours ce qui est nécessaire et rien de plus. Nous savons que les données peuvent être précieuses, c'est pourquoi nous ne vendons pas vos informations personnelles à des entreprises qui pourraient les utiliser contre vous.",
  recipients_paragraph_2:
    "Lorsqu'une demande de transport est effectuée, l'entreprise partage vos données personnelles avec le conducteur. Cela inclut toutes les informations telles que le nom, le numéro de contact et la localisation, ainsi que d'autres informations démographiques. Après avoir utilisé le service de transport, vos informations resteront visibles pour le conducteur pendant 24 à 48 heures. Cela est important car cela permet aux superviseurs, qui pourraient rencontrer un problème comme un objet oublié dans la voiture, de contacter le conducteur et de résoudre le problème avec le passager. Les passagers donnent des retours actualisés sur leurs trajets via notre application. Les données sont anonymes et restent privées entre vous et l'entreprise. Même si quelqu'un vous attribue une mauvaise note, il ne pourra pas utiliser vos commentaires contre vous ou ceux-ci ne seront plus valides. Dans certains cas, il peut être légalement nécessaire de partager des informations avec des destinataires externes, comme lorsqu'un tribunal nous l'ordonne ou lorsque nous coopérons avec une autorité de protection des données. Nous effectuons souvent ces réponses lorsque nous avons la conviction de bonne foi que la réponse est requise par la loi dans cette juridiction, lorsqu'elle sert une mission d'intérêt public, affecte les utilisateurs dans cette juridiction et est conforme à nos conditions d'utilisation. Nous avons une base juridique solide pour partager ces informations et nous documenterons notre décision en fournissant une justification.",

  security_title: '5. Sécurité de vos données personnelles',
  security_paragraph_1:
    'La sécurité des données est l’une de nos priorités, mais vos données peuvent ne pas être entièrement sécurisées. Bien que nous nous efforcions d’utiliser des méthodes de protection des données reconnues par l’industrie, il est important de garder à l’esprit qu’aucune méthode de transmission sur internet ou de stockage électronique n’est 100 % sécurisée.',

  children_privacy_title: '6. Confidentialité des enfants',
  children_privacy_paragraph_1:
    'Nous ne nous adressons à aucune personne de moins de 13 ans. Nous ne collectons pas sciemment des informations personnelles de personnes de moins de 13 ans. Si vous êtes un parent ou un tuteur et que vous réalisez que votre enfant nous a fourni des données personnelles, veuillez nous contacter. Nous sommes conscients que nous avons collecté des données personnelles de personnes de moins de 13 ans sans vérifier le consentement parental sur nos serveurs. Si cela se produit, nous supprimons les informations de nos serveurs.',
  children_privacy_paragraph_2:
    'Certains de nos services sont uniquement disponibles pour les utilisateurs de plus de 13 ans. Dans certains cas, cela signifie que nous ne pourrons pas fournir certaines fonctionnalités du service à ces utilisateurs plus jeunes.',
  children_privacy_paragraph_3:
    'Si la loi nous oblige à obtenir le consentement de vos parents pour que nous puissions collecter et traiter des données personnelles, nous ne pourrons pas le faire à moins que vous ne nous donniez leur permission.',

  links_title: "7. Liens vers d'autres sites web",
  links_paragraph_1:
    "Nous pouvons inclure des liens vers d'autres sites web qui ne sont pas exploités par nous. Si vous cliquez sur un lien tiers, vous serez redirigé vers ce site web. Il est important que vous lisiez la politique de confidentialité de chaque site que vous visitez.",
  links_paragraph_2:
    "Nous ne censurons aucun site tiers ni le contenu de ces sites. Nous n'avons aucun contrôle et n'assumons aucune responsabilité concernant le contenu, les protections, les politiques de confidentialité ou les pratiques des sites tiers avec lesquels nous sommes liés.",

  changes_title: '8. Modifications de cette politique de confidentialité',
  changes_paragraph_1:
    "Nous mettrons à jour notre politique de confidentialité de temps à autre. Si un changement est effectué, nous vous en informerons via le Forum ou par d'autres moyens.",
  changes_paragraph_2:
    "Un e-mail ou un avis visible avant que le changement n'entre en vigueur sera envoyé pour informer des modifications à venir, ainsi que pour fournir une mise à jour avec la date 'Dernière mise à jour' en haut de cette politique de confidentialité.",
  changes_paragraph_3:
    "Les visiteurs doivent vérifier périodiquement la politique de confidentialité pour toute modification qui a été publiée sur ce site. Les changements apportés à la politique de confidentialité resteront en vigueur jusqu'à ce qu'une nouvelle version soit publiée sur cette page.",

  rights_title: '9. Vos droits et contrôles',
  rights_paragraph_1:
    "Nous voulons que vous restiez maître de vos données personnelles. Nous vous fournissons les contrôles nécessaires dans l'application pour consulter toutes les informations que nous collectons sur nos utilisateurs, y compris leurs données de profil et leur historique de trajets. Nous avons également des paramètres dans l'application, tels que des options marketing et des contrôles clairs pour le consentement aux cookies dans notre application.",
  rights_paragraph_2: "Votre droit d'accès",
  rights_paragraph_3:
    'Vous avez le droit de demander une copie de toutes les informations personnelles que nous avons collectées à votre sujet. Nous ne fournirons pas toujours toutes les informations demandées, car nous devons équilibrer nos droits avec ceux des autres.',
  rights_paragraph_4: 'Votre droit de rectification',
  rights_paragraph_5:
    "Vous pouvez obtenir une meilleure assistance pour toutes vos données personnelles dans l'application. Vous avez également le droit de nous demander de mettre à jour ou de compléter tout dossier que vous estimez incomplet. Ainsi, vous aurez plus de facilité à faire fonctionner votre compte correctement.",
  rights_paragraph_6: "Votre droit à l'effacement",
  rights_paragraph_7:
    'Vous pouvez demander que vos informations personnelles stockées sur nos serveurs soient supprimées dans certaines circonstances.',
  rights_paragraph_8: 'Votre droit à la limitation du traitement',
  rights_paragraph_9:
    "Vous avez le droit de nous demander de limiter le traitement de vos informations dans certaines circonstances. Par exemple, si vous déposez une plainte auprès de l'entreprise ou si vous souhaitez exercer vos droits légaux (comme demander une indemnisation pour des dommages ou si vos données ont été piratées).",
  rights_paragraph_10: "Votre droit d'opposition au traitement",
  rights_paragraph_11:
    "Nous traitons vos données sur la base d'intérêts légitimes. Si vous souhaitez vous y opposer, vous pouvez nous en informer et demander à ce qu'une personne examine cela.",

  retention_title: '10. Conservation des données',
  retention_paragraph_1:
    'Notre application conserve les données des utilisateurs uniquement pendant le temps nécessaire pour se conformer à leurs politiques. Toutes les catégories de données (par exemple, facturation, localisation) sont conservées pendant des périodes de temps différentes en fonction du type (par exemple, 6 semaines pour les données de facturation, 12 mois pour les données de localisation).',
  retention_paragraph_2:
    "Après avoir un compte actif avec notre service, vos données personnelles sont conservées tant que vous utilisez nos services. Vous pouvez désactiver définitivement votre compte ou supprimer vos données personnelles via l'application si nécessaire. Si votre compte est fermé, les données personnelles seront supprimées conformément à nos programmes et règles de conservation. Les données relatives aux services de transport fournis aux passagers seront conservées pendant trois ans après le dernier trajet et ; les données à d'autres fins comptables seront conservées pendant sept ans après le dernier trajet.",
  retention_paragraph_3:
    "Nous conservons toutes les données nécessaires pour les exigences internes, juridiques et réglementaires afin de garantir que nous sommes une entreprise conforme. En cas de réclamations de paiement, vos informations personnelles seront conservées tant qu'elles ne sont pas satisfaites ou que la réclamation expire. L'historique des trajets personnels et les données d'utilisation de chaque individu seront conservés pendant 3 ans, après quoi elles seront rendues privées par anonymisation des données. Les informations vous concernant sont stockées de manière sécurisée et seront utilisées uniquement lorsque cela est nécessaire pour ces fins. Nous conservons les données nécessaires pour notre entreprise spécifiquement pour les besoins de l'entreprise, qui peuvent changer au fil du temps. Les informations ne seront pas collectées ni partagées avec une autre partie. Parfois, nous pourrions avoir besoin de conserver vos données pour nous conformer à nos obligations légales et appliquer nos accords et politiques.",
  retention_paragraph_4:
    "L'entreprise conservera également les données des utilisateurs à des fins d'analyse interne. Les données des utilisateurs sont conservées pendant une période plus courte, sauf si elles sont utilisées pour renforcer la sécurité ou améliorer la fonctionnalité de notre service, ou si nous sommes légalement tenus de conserver ces données pendant des périodes plus longues.",

  contact_title: 'Contactez-nous',
  contact_paragraph_1:
    'Si vous avez des questions concernant cette politique de confidentialité, vous pouvez nous contacter : ',
  contact_paragraph_2: 'Par email : manuelnobelapp@gmail.com',

  termsAndConditions_title: 'Conditions Générales',
  termsAndConditions_intro_title: "Bienvenue sur l'application NOBEL !",
  termsAndConditions_intro_paragraph:
    'NOBEL vous présente ces Conditions Générales concernant la fourniture de services, ainsi que les informations, éléments, données et exigences qui y sont contenus et qui sont la propriété de Nobel-app, situé à Petrus Huysegomsstraat 5, Sint-Pieters-Leeuw, avec le numéro d\'entreprise : 0744.455.5, ci-après désigné brièvement par "NOBEL".',
  aboutTheAppTitle: "À propos de l'application NOBEL",
  aboutTheAppIntro:
    'Pour comprendre ces Conditions Générales, il est nécessaire de comprendre :',
  appDefinition: {
    title: '1.1 "Application NOBEL (ci-après désignée par l\'Application)"',
    description:
      'Le logiciel qui offre un ensemble de services et permet leur contrat de manière électronique et à distance ;',
  },
  termsAndConditionsDefinition: {
    title: '1.2 "Conditions Générales"',
    description:
      "Les conditions générales qui déterminent l'accès et l'utilisation de l'application NOBEL par ses utilisateurs ;",
  },
  personalDataDefinition: {
    title: '1.3 "Données Personnelles"',
    description:
      'Signifie les informations relatives à une personne physique identifiée ou identifiable ("Personne Concernée") ; une personne physique est considérée comme identifiable si elle peut être identifiée, directement ou indirectement, notamment par référence à un identifiant, tel qu\'un nom, un numéro d\'identification, des données de localisation (voir Politique de confidentialité) ;',
  },
  serviceProviderDefinition: {
    title: '1.4 "Fournisseur de Services"',
    description:
      "Une personne physique ou morale avec laquelle NOBEL a un accord commercial en vertu duquel elle offre ses services sur l'Application, et qui fournira des services directement à l'Utilisateur ;",
  },
  provisionOfServicesDefinition: {
    title: '1.5 "Fourniture de Services"',
    description:
      "Les services disponibles sur l'Application NOBEL et le contrat conclu entre les Fournisseurs de Services et les Utilisateurs ;",
  },
  userDefinition: {
    title: '1.6 "Utilisateur"',
    description:
      "Une personne physique, âgée de plus de 18 ans, qui accède et utilise l'Application conformément aux présentes Conditions Générales ;",
  },
  contractDefinition: {
    title: '1.7 "Contrat"',
    description:
      'Désigne un accord commercial entre le Fournisseur de Services et NOBEL, qui comprend :',
  },
  contractDetails: {
    termsAndConditions: '1.7.1 Ces Conditions Générales ;',
    specialTerms:
      "1.7.2 Des conditions spéciales divulguées dans l'Application NOBEL, par exemple concernant les prix ou la description des services ;",
    additionalTerms:
      "1.7.3 Des Conditions Générales supplémentaires ou des documents à signer à l'avenir entre le Fournisseur de Services et NOBEL.",
  },
  priceDefinition: {
    title: '1.8 "Prix"',
    description:
      "Le montant que l'Utilisateur doit payer au Fournisseur de Services pour les Services fournis, ainsi que le montant à retenir pour le paiement de l'intermédiation par NOBEL.",
  },
  intermediationFeesDefinition: {
    title: '1.9 "Frais d\'Intermédiation"',
    description:
      "Désigne les frais que le Fournisseur de Services doit payer à NOBEL pour l'utilisation de la Plateforme.",
  },
  paymentsDefinition: {
    title: '1.10 "Paiements"',
    description:
      'Carte, système de paiement et autres méthodes de paiement choisies par les utilisateurs via NOBEL pour payer la fourniture des services.',
  },
  acceptanceAndConclusionTitle:
    'Acceptation et conclusion du contrat avec NOBEL',
  acceptanceAndConclusion: {
    item1:
      "2.1 Pour accéder à l'application NOBEL, vous devez installer l'application sur votre appareil mobile (qu'il s'agisse d'un smartphone ou d'une tablette, fonctionnant sous iOS ou Android).",
    item2:
      "2.2 Le téléchargement et l'installation de l'application NOBEL sur votre appareil mobile sont gratuits, bien qu'il puisse y avoir des frais associés à l'utilisation du réseau de télécommunications et des données mobiles, qui sont entièrement et exclusivement supportés par le fournisseur de services et doivent être payés par le fournisseur de services conformément aux termes du contrat avec l'opérateur de télécommunications concerné.",
    item3:
      "2.3 Après la création du compte, l'authentification est effectuée, ce qui consiste à envoyer à l'utilisateur, par SMS ou par e-mail, un code de sécurité, personnel, confidentiel et non transférable. Le fournisseur de services est responsable de sa garde, de sa confidentialité et de sa sécurité.",
    item4:
      "2.4 Le fournisseur de services doit garder ses identifiants confidentiels et limiter l'accès à son compte, notamment en protégeant ses identifiants contre la perte, le vol ou l'utilisation abusive. Toute perte d'identifiants doit être signalée à NOBEL.",
    item5:
      "2.5 Tout dommage résultant de l'utilisation non autorisée des identifiants est de la seule responsabilité du fournisseur de services.",
    item6: "2.6 Le fournisseur de services déclare et garantit qu'il :",
    item6_1:
      "2.6.1 A soigneusement examiné, compris et accepté d'être lié par le présent accord, y compris toutes les obligations en découlant pour le fournisseur de services telles que décrites ci-après ;",
    item6_2:
      "2.6.2 Ne permettra pas à d'autres d'utiliser le compte du fournisseur de services, ni de le transférer ou de le céder à d'autres personnes sans l'autorisation écrite expresse de NOBEL ;",
    item6_3:
      "2.6.3 Ne copiera ni ne distribuera le logiciel de l'application, ni tout autre contenu de NOBEL sans l'autorisation écrite préalable de NOBEL.",
    item7:
      "2.7 En cas de violation de toute disposition légale applicable, des présentes conditions générales ou d'autres dispositions contractuelles applicables, NOBEL se réserve le droit de suspendre ou de résilier le compte du fournisseur de services ou de prendre toute autre mesure qu'il jugera appropriée à sa seule discrétion.",
  },

  contractualRelationshipTitle:
    "Relation contractuelle entre le prestataire de services et l'utilisateur",
  contractualRelationship: {
    item1:
      "3.1 Le prestataire de services accepte qu'il puisse conclure un contrat de prestation de services avec l'utilisateur.",
    item2:
      "3.2 Les services sont fournis par le prestataire de services en tant qu'entreprise indépendante et, par conséquent, le prestataire de services ne sera pas considéré comme un employé ou un travailleur ou équivalent vis-à-vis de NOBEL, en ce qui concerne les services fournis.",
    item3:
      "3.3 Nonobstant le fait que NOBEL ne soit pas partie à la relation contractuelle entre le prestataire de services et l'utilisateur, le prestataire de services s'engage à :",
    item3_1:
      "3.3.1 Souscrire une police d'assurance accidents du travail (conformément à la loi n° ______ ;",
    item3_2:
      '3.3.2 Assurer la sécurité et la santé au travail (conformément aux dispositions générales de la loi n° ______) ;',
    item3_3:
      "3.3.3 S'assurer que tous ses employés et/ou prestataires de services sont aptes à travailler (conformément à l'ordonnance _____________) ;",
    item3_4:
      "3.3.4 Ne pas fournir de services sous l'influence de l'alcool ou de drogues et ne pas prendre de mesures nuisibles ou susceptibles de nuire à la sécurité des utilisateurs ou des tiers, ce qui pourrait affecter l'image et la crédibilité de NOBEL ;",
    item3_5:
      '3.3.5 Se comporter de manière diligente, en évitant les comportements à risque ;',
    item3_6:
      '3.3.6 Souscrire une assurance responsabilité civile et toute autre assurance requise dans la juridiction applicable pour la fourniture de services à domicile ;',
    item3_7:
      "3.3.7 Disposer de tout l'équipement, matériel et moyens nécessaires à la fourniture des services, dont les coûts seront supportés par lui/elle, y compris le carburant pour les déplacements.",
  },
  priceTitle: 'Prix',
  price: {
    item1:
      "4.1 Le prix du service est défini dans l'application NOBEL, ainsi que les taxes statutaires applicables. De même, le prestataire de services pourra voir le montant associé au pourcentage de 30 % d'intermédiation qui sera payé à NOBEL et qui sera automatiquement retenu.",
    item2:
      "4.2 D'autre part, l'application NOBEL fournit également un prix pour chaque heure supplémentaire de service, qui doit être activée par le prestataire de services dans les cas où, en raison d'une description incorrecte, inexacte ou insuffisante de l'utilisateur, le travail s'avère plus complexe que demandé. L'utilisateur a la possibilité de choisir de continuer la prestation des services ou de la refuser.",
    item3:
      "4.3 Si l'utilisateur n'accepte pas le nouveau prix indiqué, la prestation des services sera annulée, donnant lieu à un paiement d'un montant de 30 €.",
  },
  meansOfPaymentTitle: 'Moyens de Paiement',
  meansOfPayment: {
    item1:
      "5.1 Le Fournisseur de Services s'engage à fournir des informations valides, à jour et complètes sur une carte de crédit ou de débit lors de l'inscription à l'application NOBEL.",
    item2:
      "5.2 Les paiements seront effectués tous les 15 jours, afin que NOBEL puisse garantir l'efficacité et la réussite des services fournis.",
    item3:
      "5.3 Si NOBEL n'est pas en mesure de prélever un montant dû pour un service ou tout autre montant de la carte de crédit ou de débit d'un utilisateur, nous nous réservons le droit de suspendre temporairement ou de désactiver tout ou une partie de leur accès à l'application. Cela n'affecte aucun autre droit ou recours disponible pour nous (en tant que collecteur de dettes au nom du Fournisseur de Services), et pour le Fournisseur de Services.",
    item4:
      "5.4 Les paiements sont effectués par un tiers indépendant qui retiendra le montant du service avant qu'il ne soit exécuté, ce montant étant débité de la carte de crédit de l'utilisateur.",
    item5:
      "5.5 La facture sera envoyée par NOBEL, sous forme numérique, à l'adresse e-mail fournie par le Fournisseur de Services, après confirmation que la prestation de services a été correctement terminée.",
  },
  userIdentificationTitle: "Identification de l'utilisateur",
  userIdentification: {
    item1:
      "6.1 Avant de commencer la prestation des services, le prestataire de services s'engage à se rendre à l'adresse indiquée et à identifier l'utilisateur.",
    item2:
      "6.2 Si le prestataire de services commet une erreur dans l'identification de l'utilisateur et que le paiement est effectué par une personne qui n'a pas reçu le service, NOBEL remboursera le montant à l'utilisateur. Dans ce cas, le prestataire de services ne sera pas en droit de percevoir le tarif correspondant à la prestation de services effectuée et assumera les coûts de remboursement à NOBEL.",
  },
  Responsibilitytitle: 'Responsabilité',
  Responsibility: {
    item1:
      "7.1 NOBEL n'est en aucun cas partie prenante dans la relation contractuelle établie entre l'Utilisateur et le Prestataire de services. Par conséquent, ils reconnaissent qu'aucune responsabilité ne peut lui être attribuée, en particulier en ce qui concerne l'exécution du contrat et le respect des obligations contractuelles des parties.",
    item2:
      "7.2 De même, NOBEL ne peut être tenue responsable de la non-exécution d'un contrat par l'une des parties ou d'une responsabilité extra-contractuelle, ainsi que de toute perte ou dommage qui pourrait en résulter pour l'une ou l'autre des parties.",
    item3:
      "7.3 NOBEL ne garantit pas le fonctionnement permanent ou ininterrompu de l'application NOBEL. Ainsi, elle ne peut être tenue responsable de l'impossibilité de son utilisation ou de tout dommage ou préjudice pouvant en résulter :",
    item3_1:
      "7.3.1 Les difficultés d'utilisation de l'application, notamment en raison de délais, d'interruptions, d'erreurs, d'interférences ou de suspensions des communications, de virus, de bogues ou de dysfonctionnements ;",
    item3_2:
      "7.3.2 Les retards causés par des défaillances ou des surcharges du trafic Internet ou d'autres systèmes électroniques ;",
    item3_3:
      "7.3.3 Les actes illégitimes de tiers, les erreurs ou les défauts de sécurité dus à l'utilisation d'équipements obsolètes ou non sécurisés ou de navigateurs, des défaillances des services de communication électronique utilisés par le Prestataire de services, ainsi que les dommages, erreurs et inexactitudes qui pourraient résulter de leur dysfonctionnement.",
    item4:
      "7.4 Le Prestataire de services assume l'entière responsabilité de ses actes ou omissions et des conséquences en découlant, déchargeant NOBEL de toute responsabilité pour toute action directe ou indirecte, qu'elle soit incidente ou criminelle, liée à toute mauvaise utilisation ou utilisation illégale de l'application NOBEL.",
    item5:
      "7.5 Le Prestataire de services reconnaît et accepte qu'aucune responsabilité, directe ou indirecte, ne peut être attribuée à NOBEL du fait de l'utilisation de l'application NOBEL.",
    item6:
      "7.6 Le Prestataire de services est responsable de l'utilisation de l'application NOBEL, même si elle est effectuée par des tiers, avec ou sans son autorisation. Toutefois, si une transaction est prouvée avoir été réalisée par un tiers, il est présumé que celle-ci a été consentie ou facilitée par négligence par le Prestataire de services.",
    item7:
      "7.7 Le Prestataire de services et NOBEL conviennent que l'enregistrement informatique ou sa reproduction sur tout support, y compris sur papier, constitue une preuve des opérations effectuées conformément aux présentes Conditions Générales.",
    item8:
      "7.8 NOBEL n'assume aucune responsabilité pour toute perte ou dommage que le Prestataire de services pourrait subir en lien avec le contrat conclu avec l'Utilisateur ou résultant de l'utilisation de l'application NOBEL, y compris, sans limitation :",
    item8_1:
      '7.8.1 Tout accident survenant lors de la prestation de services ;',
    item8_2:
      "7.8.2 Tout dommage matériel direct ou indirect ou perte d'argent ;",
    item8_3: '7.8.3 Perte de bénéfices ou de profits anticipés ;',
    item8_4:
      "7.8.4 Perte d'affaires, de contrats, de contacts, de prestige, de réputation et toute perte résultant de l'interruption des affaires ;",
    item8_5: '7.8.5 Perte ou inexactitude des données ;',
    item8_6: '7.8.6 Tout autre dommage indirect ou consécutif.',
  },
  Sanctions: {
    title: 'Sanctions',
    description:
      "NOBEL se réserve le droit d'exclure de l'utilisation de l'application NOBEL, immédiatement et sans préavis, tout Prestataire de Services qui :",
    item1:
      "8.1 Violente ou est suspecté d'avoir violé l'une des dispositions des présentes Conditions Générales et de la Politique de Confidentialité associée ;",
    item2:
      "8.2 Utilise l'application NOBEL avec des données d'enregistrement fausses, inexactes ou incomplètes ;",
    item3: "8.3 Utilise frauduleusement l'application NOBEL ;",
    item4:
      "8.4 Manipule, modifie, supprime ou efface des données, des programmes ou des systèmes informatiques associés à l'application NOBEL ;",
    item5:
      "8.5 Contacte directement les utilisateurs de l'application NOBEL, par tous moyens, dans le but d'établir des partenariats ou des relations d'affaires ;",
    item6:
      "8.6 A été signalé pour comportement frauduleux ou nuisible pouvant affecter l'image et la crédibilité de NOBEL.",
  },
  IntellectualPropertyRightsTitle: 'Droits de propriété intellectuelle',
  IntellectualPropertyRights: {
    item1:
      "9.1 En installant et en utilisant l'application NOBEL, le prestataire de services reconnaît et accepte que les droits de propriété intellectuelle sur tout le contenu de l'application NOBEL appartiennent à NOBEL, y compris les informations, les outils, les conceptions graphiques, tous les composants multimédias, le logo et toutes les figures ou les textes.",
    item2:
      "9.2 La reproduction totale ou partielle de toute information ou contenu de l'application NOBEL, sa location ou sa vente, sans l'autorisation préalable de NOBEL est interdite.",
    item3:
      "9.3 Les signes distinctifs de l'application NOBEL sont protégés et ne peuvent être utilisés par des tiers sans le consentement préalable et exprès de NOBEL.",
    item4:
      "9.4 Il est strictement interdit au prestataire de services d'essayer d'accéder, de modifier, de reproduire, de distribuer, de vendre, de licencier ou de copier le contenu de NOBEL et ses droits de propriété intellectuelle, en tout ou en partie.",
    item5:
      "9.5 Tous les droits de propriété intellectuelle sur le logiciel, son contenu et toute documentation associée, dans toutes les parties du monde, appartiennent à NOBEL ou à ses concédants et ne peuvent être copiés, distribués, téléchargés, republicés, décompilés, désassemblés ou transmis sous aucune forme sans l'autorisation écrite préalable de NOBEL.",
  },
  UserRatingsTitle: 'Évaluations des utilisateurs',
  UserRatings: {
    item1:
      "10.1 NOBEL vise à garantir la qualité, l'efficacité et le succès des services qu'elle propose sur sa plateforme aux utilisateurs. À cet égard, l'évaluation de l'utilisateur est un élément décisif pour la continuation de la relation contractuelle entre NOBEL et le Prestataire de services.",
    item2:
      "10.2 L'utilisateur peut laisser des commentaires et évaluer la qualité de l'accueil et du service fourni de 1 à 5.",
    item3:
      '10.3 Dans le cas où le Prestataire de services est évalué trois fois avec des scores inférieurs à 3 sur une échelle de 1 à 5, il peut être contacté par NOBEL pour fournir des éclaircissements. Sans préjudice de ce qui précède, NOBEL se réserve le droit de résilier immédiatement et sans préavis le contrat entre NOBEL et le Prestataire de services.',
  },
  TermAndTerminationTitle: 'Durée et Résiliation',
  TermAndTermination: {
    item1:
      "11.1 Le Fournisseur de Services peut résilier l'Accord à tout moment en envoyant un préavis écrit à NOBEL avec un préavis d'au moins 15 (quinze) jours.",
    item2:
      "11.2 NOBEL peut résilier l'Accord à tout moment et pour toute raison, à la seule discrétion de NOBEL, en notifiant le Fournisseur de Services avec un préavis d'au moins 5 (cinq) jours.",
    item3:
      "11.3 NOBEL se réserve le droit de résilier l'Accord et de bloquer l'accès au Fournisseur de Services sans préavis en cas de violation de l'Accord et/ou de toute loi ou règlement applicable par le Fournisseur de Services.",
    item4:
      '11.4 Après la résiliation de cet Accord pour toute raison, tous les droits accordés au Fournisseur de Services en vertu de cet Accord cesseront immédiatement, et le Fournisseur de Services cessera toutes les activités autorisées par cet Accord.',
  },
  DisputeResolutionTitle: 'Règlement des litiges',
  DisputeResolution: {
    item1:
      "12.1 En cas de litige concernant la fourniture des services, veuillez nous contacter en premier lieu à l'adresse suivante : info@nobel-app.com.",
    item2:
      "12.2 Dans le cas peu probable où un litige ne pourrait être résolu à l'amiable, nous discuterons et nous accorderons avec le prestataire de services sur la manière la plus efficace de résoudre le litige.",
  },
  FinalTransitionalProvisionsTitle: 'Dispositions finales et transitoires',
  FinalTransitionalProvisions: {
    item1:
      "13.1 NOBEL se réserve le droit de modifier unilatéralement la disposition et la configuration de l'application NOBEL à tout moment et sans préavis.",
    item2:
      '13.2 NOBEL se réserve le droit de mettre à jour ces Termes et Conditions de temps à autre.',
    item3:
      "13.3 Les changements ou mises à jour peuvent être justifiés par le besoin d'implémenter de nouvelles fonctionnalités de l'application NOBEL ainsi que par des changements dans la législation applicable.",
    item4:
      "13.4 NOBEL s'efforcera de notifier les Prestataires de Services des changements ou mises à jour de ces Termes et Conditions au moins 14 (quatorze) jours à l'avance.",
    item5:
      "13.5 Si l'une des dispositions de ces Termes et Conditions est jugée inapplicable ou non exécutoire, cela n'affectera pas l'applicabilité et la validité des autres dispositions.",
  },
  ApplicableLawAndJurisdictionTitle: 'Loi applicable et juridiction',
  ApplicableLawAndJurisdiction: {
    item1:
      "14.1 L'application NOBEL, ainsi que ces Conditions Générales, sont soumises à la législation en vigueur dans le système juridique belge.",
    item2:
      "14.2 NOBEL et l'utilisateur acceptent et conviennent que tout litige découlant de ces Conditions Générales, ainsi que de la Politique de Confidentialité qui en fait partie intégrante, sera tranché par le Tribunal________________________________",
  },

  ItShouldBeAdded: "Il convient d'ajouter :",
  ServiceProviderWorkNonCompliance:
    'Dans le cas où le Prestataire de services ne réalise pas le travail conformément aux règles du métier et aux normes de qualité requises par NOBEL, nous nous réservons expressément le droit de ne pas procéder au paiement du service en question.',
  QualifiedServiceProviderSubstitution:
    "NOBEL se réserve également le droit d'envoyer un autre prestataire de services qualifié pour corriger ou compléter le travail initialement demandé.",
  QualityStandardsSatisfaction:
    "Cette mesure vise à garantir la satisfaction de nos utilisateurs et à maintenir les hauts standards de qualité auxquels NOBEL s'engage.",
  AgreementAcknowledgment:
    'En acceptant ces Conditions Générales, le Prestataire de services reconnaît et accepte cette disposition, comprenant que le non-respect des exigences de qualité peut entraîner une non-rémunération de ses services et la mise en œuvre de mesures correctives par NOBEL.',
  about_title: 'À propos',
  AboutDescription:
    "Bienvenue sur Nobel, où la commodité rencontre l'expertise ! Chez Nobel, nous comprenons les défis liés à l'entretien d'une maison ou d'une entreprise, et nous croyons que tout le monde mérite un accès à des professionnels de service fiables et qualifiés. Notre plateforme est née de la vision de créer une connexion fluide entre les demandeurs de services et les prestataires, rendant les services à domicile plus accessibles, efficaces et agréables.",
  MissionDescription:
    'Notre mission est de simplifier votre vie en fournissant une solution tout-en-un pour tous vos besoins en services à domicile. Que ce soit pour réparer un robinet qui fuit, rafraîchir votre espace de vie avec un nettoyage en profondeur, ou résoudre des problèmes électriques, Nobel est là pour vous connecter à des professionnels vérifiés qui fournissent des services de qualité.',

  whyNobel: [
    {
      title: 'Qualité en laquelle vous pouvez avoir confiance',
      description:
        "Nous priorisons votre satisfaction et tranquillité d'esprit. Tous nos prestataires de services subissent un processus de sélection rigoureux pour garantir qu'ils respectent les normes les plus élevées de professionnalisme et d'expertise.",
    },
    {
      title: 'La commodité à portée de main',
      description:
        "Avec quelques taps sur votre smartphone, vous pouvez réserver une variété de services et avoir des professionnels qualifiés chez vous. Dites adieu aux tracas de la recherche et de la planification - Nobel s'occupe de tout.",
    },
    {
      title: 'La sécurité avant tout',
      description:
        'Votre sécurité est notre priorité. Notre plateforme garantit que toutes les transactions sont sécurisées, et nous fournissons un suivi en temps réel des prestataires de services afin que vous sachiez exactement quand vous les attendre.',
    },
    {
      title: 'Des services variés',
      description:
        "Des travaux de plomberie et d'électricité au nettoyage et au jardinage, nous proposons une gamme complète de services pour répondre à vos besoins uniques. Quel que soit le travail, nous avons le bon professionnel pour vous.",
    },
    {
      title: 'Expérience facile à utiliser',
      description:
        'Notre application est conçue pour être conviviale, vous permettant de naviguer facilement, de réserver des services et de communiquer avec les prestataires de services. Nous valorisons votre temps, et notre plateforme est construite pour rendre tout le processus fluide.',
    },
    {
      title: 'Un Support Fiable',
      description:
        'Nous nous engageons à fournir un service client exceptionnel. Notre équipe dévouée est toujours prête à répondre à vos questions et à vous accompagner pour une expérience sans souci.',
    },
  ],

  joinSection: {
    title: 'Rejoignez la communauté Nobel',
    description:
      'Que vous soyez un demandeur de services à la recherche de professionnels fiables ou un prestataire de services qualifié souhaitant développer votre entreprise, Nobel vous invite à rejoindre notre communauté. Ensemble, nous redéfinissons la manière dont les services à domicile sont fournis, simplifiant ainsi la vie et la rendant plus agréable pour tous.',
  },
  sloganSection: {
    title: "Découvrez la commodité, la fiabilité et l'excellence de Nobel.",
    subtitle:
      "Téléchargez l'application aujourd'hui et découvrez une nouvelle ère des services à domicile.",
  },
  product: 'Produit',
  customer_app: 'Application Client',
  provider_app: 'Application Fournisseur',
  home_services: {
    line1: 'Services à domicile chez',
    line2: 'votre porte.',
  },
  rights_reserved: 'Nobel. Tous droits réservés.',
  help: 'Aide',
  delivery_message:
    'Rapide, fiable et garanti pour répondre à vos attentes, livré directement à votre porte',
  home_services_title: 'Services à domicile fiables',
  home_services_subtitle: 'À portée de main !',
  services__top_title: 'Tous les services',
  join_nobel_team:
    "Êtes-vous un professionnel expérimenté et souhaitez-vous faire partie de l'équipe de techniciens de Nobel ? Inscrivez-vous maintenant !",
  work_with_us: 'Voulez-vous travailler avec nous ?',
  tell_us: 'Dites-nous ce que vous recherchez',
  your_name: 'Nom',
  your_email: 'E-mail',
  your_subject: 'Sujet',
  your_message: 'Message',
  submitting: 'Soumission en cours...',
  success: 'Soumission réussie!',
  submit_request: 'Soumettre la demande',
  something_went_wrong:
    "Quelque chose s'est mal passé, veuillez réessayer plus tard.",
  home_title: 'Accueil',
  name_required: 'Le nom est requis',
  email_required: "L'e-mail est requis",
  invalid_email: "Format d'e-mail invalide",
  message_required: 'Le message est requis',
  captcha_required: 'Captcha requis',
  subject_required: 'Le sujet est requis',
  name_minlength: 'Le nom doit comporter au moins 3 caractères.',
  name_maxlength: 'Le nom ne doit pas dépasser 50 caractères.',
  subject_minlength: "L'objet doit comporter au moins 3 caractères.",
  subject_maxlenght: "L'objet ne doit pas dépasser 30 caractères.",
  message_minlength: 'Le message doit comporter au moins 10 caractères.',
  message_maxlength: 'Le message ne doit pas dépasser 500 caractères.',
  regex_name: 'Vérifiez le nom',
  why_nobel: 'Pourquoi Nobel',
  what_makes_us: "Qu'est-ce qui nous rend meilleurs que les autres.",

  faq: {
    general: {
      title: 'Général',
      questions: [
        {
          question: "Qu'est-ce que Nobel ?",
          answer:
            'Nobel est une plateforme pratique qui vous connecte avec des prestataires de services fiables et compétents pour divers besoins de maintenance et de réparation à domicile, tels que la plomberie, les travaux électriques, le nettoyage, et plus encore.',
        },
        {
          question: 'Comment fonctionne Nobel ?',
          answer:
            "Il vous suffit de télécharger l'application ou de visiter notre site Web, de sélectionner le service dont vous avez besoin, de choisir un prestataire et de programmer un rendez-vous à votre convenance.",
        },
        {
          question: 'Nobel est-il disponible dans ma région ?',
          answer:
            "Nous étendons constamment nos zones de service. Entrez votre emplacement dans l'application ou sur le site Web pour vérifier la disponibilité.",
        },
      ],
    },
    booking: {
      title: 'Réservation et Services',
      questions: [
        {
          question: 'Comment réserver un service ?',
          answer:
            "Vous pouvez réserver un service en sélectionnant la catégorie, en choisissant un prestataire de services et en confirmant votre rendez-vous. Le paiement peut être effectué en toute sécurité via l'application.",
        },
        {
          question: "Puis-je programmer un service à l'avance ?",
          answer:
            'Oui ! Vous pouvez réserver des services pour le jour même ou les planifier pour une date ultérieure en fonction de votre disponibilité.',
        },
        {
          question: 'Quels services proposez-vous ?',
          answer:
            "Nous proposons divers services, notamment la plomberie, les travaux électriques, le nettoyage, le jardinage, la réparation d'appareils, la peinture, les tâches de bricolage, et plus encore.",
        },
      ],
    },
    pricing: {
      title: 'Tarification et Paiements',
      questions: [
        {
          question: 'Comment la tarification est-elle déterminée ?',
          answer:
            'Les prix dépendent du type de service, de la durée et de la complexité. Vous verrez une estimation du prix avant de confirmer votre réservation.',
        },
        {
          question: 'Quels modes de paiement acceptez-vous ?',
          answer:
            "Nous acceptons les cartes de crédit/débit principales, les portefeuilles numériques et d'autres méthodes de paiement sécurisées disponibles dans votre région.",
        },
        {
          question: "Y a-t-il des frais d'annulation ?",
          answer:
            "Les annulations effectuées dans un certain délai sont gratuites. Cependant, les annulations de dernière minute peuvent entraîner des frais. Consultez notre politique d'annulation pour plus de détails.",
        },
      ],
    },
    support: {
      title: 'Support et Problèmes',
      questions: [
        {
          question: 'Que faire si je ne suis pas satisfait du service ?',
          answer:
            "Votre satisfaction est notre priorité. Si vous n'êtes pas satisfait d'un service, vous pouvez contacter notre équipe de support pour résoudre le problème.",
        },
        {
          question: 'Comment contacter le support client ?',
          answer:
            "Vous pouvez nous contacter via le chat intégré à l'application, l'email de support, le téléphone ou notre formulaire de contact.",
        },
        {
          question: 'Puis-je reprogrammer ma réservation ?',
          answer:
            "Oui, vous pouvez modifier votre rendez-vous via l'application, en fonction de la disponibilité du prestataire.",
        },
      ],
    },
  },
  servicestoptitle1: 'Salon pour hommes',
  servicestoptitle2: 'Salon de beauté pour femmes',

  services_list1_top: {
    image01: [
      {
        largeDesc: 'Coupe de cheveux simple',
        smallDesc: 'Salon pour hommes',
      },
    ],
    image02: [
      {
        largeDesc: 'Taille de barbe',
        smallDesc: 'Salon pour hommes',
      },
    ],
    image03: [
      {
        largeDesc: 'Lavage de cheveux',
        smallDesc: 'Salon pour hommes',
      },
    ],
    image04: [
      {
        largeDesc: 'Soin du visage',
        smallDesc: 'Salon pour hommes',
      },
    ],
    image05: [
      {
        largeDesc: 'Rasage',
        smallDesc: 'Salon pour hommes',
      },
    ],
  },

  services_list2_top: {
    image06: [
      {
        largeDesc: 'Pédicure',
        smallDesc: 'Salon de beauté pour femmes',
      },
    ],
    image07: [
      {
        largeDesc: 'Manucure',
        smallDesc: 'Salon de beauté pour femmes',
      },
    ],
    image08: [
      {
        largeDesc: 'Coiffure',
        smallDesc: 'Salon de beauté pour femmes',
      },
    ],
    image09: [
      {
        largeDesc: 'Massage corporel',
        smallDesc: 'Salon de beauté pour femmes',
      },
    ],
    image10: [
      {
        largeDesc: 'Massage du visage',
        smallDesc: 'Salon de beauté pour femmes',
      },
    ],
  },

  small_title_card1: 'Lavage de voiture',
  big_title_card1: 'Obtenez des voitures impeccablement propres',
  button_explore_card1: 'Explorez maintenant',
  small_title_card2: 'Entretien ménager',
  big_title_card2: 'Nettoyez votre maison sans aucun tracas',
  button_explore_card2: 'Explorer maintenant',
  services_bottom_title: 'Nettoyage & Réparations',

  services_list1_bottom: {
    image11: [
      {
        largeDesc: 'Coupe de cheveux simple',
        smallDesc: 'Salon pour hommes',
      },
    ],
    image12: [
      {
        largeDesc: 'Coupe de cheveux simple',
        smallDesc: 'Salon pour hommes',
      },
    ],
    image13: [
      {
        largeDesc: 'Coupe de cheveux simple',
        smallDesc: 'Salon pour hommes',
      },
    ],
  },
  "delete_account": "Supprimer le compte",
  
  "delete_title": "Demander la suppression du compte",
  "delete_description": "Saisissez votre numéro de téléphone ci-dessous pour demander la suppression de votre compte et de toutes les données associées.",
  "delete_phone_label": "Numéro de téléphone (avec indicatif)",
  "delete_phone_placeholder": "Entrez votre numéro avec indicatif",
  "delete_button": "Demander la suppression",
  "delete_success": "Un e-mail de confirmation de suppression a été envoyé.",
  "delete_error": "Impossible de traiter votre demande. Veuillez vérifier votre numéro de téléphone."


};
